/**
 * Splits a filename into its base name and extension (including the leading dot).
 * Returns `{ base: filename, ext: '' }` for files with no extension,
 * a leading dot (e.g. `.gitignore`), or a trailing dot.
 */
export function splitFilename(filename: string): { base: string; ext: string } {
  const dot = filename.lastIndexOf('.')
  if (dot <= 0 || dot === filename.length - 1) return { base: filename, ext: '' }
  return { base: filename.slice(0, dot), ext: filename.slice(dot) }
}
